export function formatPhone(value: string): string {
    // Удаляем все нецифровые символы
    const digits = value.replace(/\D/g, '')

    // Обрабатываем разные варианты ввода
    if (!digits) {
        return ''
    }

    // Если начинается с 8, заменяем на 7
    let phoneDigits = digits
    if (phoneDigits.startsWith('8')) {
        phoneDigits = '7' + phoneDigits.slice(1)
    }

    // Если не начинается с 7, добавляем 7
    if (!phoneDigits.startsWith('7')) {
        phoneDigits = '7' + phoneDigits
    }

    // Ограничиваем длину (7 + 10 цифр = 11)
    phoneDigits = phoneDigits.slice(0, 11)

    // Форматируем: +7 (XXX) XXX-XX-XX
    let formatted = '+7'

    if (phoneDigits.length > 1) {
        const areaCode = phoneDigits.slice(1, 4)
        formatted += ` (${areaCode}`
    }

    if (phoneDigits.length > 4) {
        const firstPart = phoneDigits.slice(4, 7)
        formatted += `) ${firstPart}`
    }

    if (phoneDigits.length > 7) {
        const secondPart = phoneDigits.slice(7, 9)
        formatted += `-${secondPart}`
    }

    if (phoneDigits.length > 9) {
        const thirdPart = phoneDigits.slice(9, 11)
        formatted += `-${thirdPart}`
    }

    return formatted
}

export function formatPhoneToApi(value: string): string {
    // Удаляем все нецифровые символы
    const digits = value.replace(/[^\d]/g, '')

    // Обрабатываем разные варианты ввода
    if (!digits) {
        return ''
    }

    // Если начинается с 8, заменяем на 7
    let phoneDigits = digits
    if (phoneDigits.startsWith('8')) {
        phoneDigits = '+7' + phoneDigits.slice(1)
    }

    if(!phoneDigits.startsWith('+')){
        return '+' + phoneDigits
    }

    return phoneDigits
}
